module.exports = __webpack_public_path__ + "img/login-screen.3f97fc19.png";